import CustomButton from 'components/CustomButton'
import { useNavigate } from 'react-router-dom'
import { TableCell, TableRow } from '../../../components/table/CustomTable'
import { isoToLocaleFormat } from 'helpers/dateTimeHelper'
import CustomIcon from 'components/CustomIcon'
import { DangerButton } from 'components/CustomButton'
import { capitalizeAndRemoveUnderscore } from 'helpers/stringHelper'
import { utcDateTimeToLocalString } from 'helpers/dateTimeHelper'
import Status, { Tag } from 'components/table/Status'
import { LinkButton } from 'components/CustomButton'
import { toast } from 'react-toastify'
import { capitalizeFirstLetter } from 'helpers/stringHelper'
import { isEmpty, isRegExp } from 'lodash'
import { filterTypes } from '../constants'

const NotificationItem = ({
  item,
  onEdit,
  onDelete,
  setModalData,
  setDeleteModal,
  isRecurring,
  ...props
}) => {
  const navigate = useNavigate()

  const appliedFilters = item?.filters?.filter(
    (i) => !i.hasOwnProperty('products'),
  )

  function isEditingAllowed() {
    const currentTime = new Date()
    const toLocalTime = new Date(
      new Date(`${item.scheduled_at}Z`).toLocaleString(undefined, {
        timeZone: 'Asia/Kathmandu',
      }),
    )
    const currentTimeInMillisecond = currentTime.getTime()
    const scheduledTimeInMillisecond = toLocalTime.getTime() - 30 * 60000
    return scheduledTimeInMillisecond > currentTimeInMillisecond
  }

  const getFilterComponents = () => {
    return (
      <div className="flex items-start flex-wrap min-w-[200px]">
        {appliedFilters?.map((filter, index) => (
          <div
            key={`notification-item-${index}`}
            className="flex items-start flex-wrap"
          >
            {filter?.hasOwnProperty('from') || filter?.hasOwnProperty('to') ? (
              <Tag
                key={filter.type}
                label={`${capitalizeFirstLetter(filter?.type)}: ${filter?.from ?? 'N/A'
                  } - ${filter?.to ?? 'N/A'}`}
                className="text-xs py-1 font-medium"
              />
            ) : filter?.hasOwnProperty('start') ||
              filter?.hasOwnProperty('end') ? (
              <>
                {filter?.hasOwnProperty('start') ? (
                  <Tag
                    key={`filter.type`}
                    label={`Min Cart Value: NPR. ${filter?.start}`}
                    className="text-xs py-1 font-medium"
                  />
                ) : (
                  ''
                )}
                {filter?.hasOwnProperty('end') ? (
                  <Tag
                    key={filter.type}
                    label={`Max Cart Value: NPR. ${filter?.end}`}
                    className="text-xs py-1 font-medium"
                  />
                ) : (
                  ''
                )}
              </>
            ) : (
              filter.type === "guest" ?
                <Tag
                  key={filter.type}
                  label={`${capitalizeFirstLetter(
                    filter?.type,
                  )}`}
                  className="text-xs py-1 font-medium"
                />
                :
                <Tag
                  key={filter.type}
                  label={`${capitalizeFirstLetter(
                    filter?.type,
                  )}: ${capitalizeFirstLetter(filter?.value)}`}
                  className="text-xs py-1 font-medium"
                />
            )}
          </div>
        ))}
        {getCartWishlistFilters()}
        {item.filter_type === 'user' && isEmpty(item.filters) && (
          <Tag label={`GENDER: ALL`} className="text-xs py-1 font-medium" />
        )}
        {!item?.filter_type &&
          <Tag label={`All Users`} className="text-xs py-1 font-medium" />
        }
      </div>
    )
  }

  const getCartWishlistFilters = () => {
    const products = item?.filters?.filter((i) => i.hasOwnProperty('products'))
    const count = products?.length
      ? products?.reduce(
        (previous, current) => previous + current.products.length,
        0,
      )
      : 0
    return count !== 0 ? (
      <Tag
        label={
          <div className="flex items-center space-x-1.5">
            <span>{count} products</span>
            <span>|</span>
            <LinkButton
              onClick={() => {
                setModalData({
                  type: 'product',
                  data: item?.filters?.filter((i) =>
                    i.hasOwnProperty('products'),
                  ),
                })
              }}
              className="text-xs font-medium"
            >
              View
            </LinkButton>
          </div>
        }
        className="text-xs py-1 font-medium"
      />
    ) : (
      <></>
    )
  }

  return (
    <TableRow {...props}>
      <TableCell>
        <div className="flex flex-col min-w-[200px] max-w-[200px] 2xl:max-w-[500px]">
          <div className="font-bold mb-1 truncate">{item?.title}</div>
          <div className="text-2-clamp break-words">{item?.message}</div>
        </div>
      </TableCell>
      {isRecurring && (
        <>
          <TableCell>
            {item.schedule_type === 'RECURRING' ? (
              <>
                <div>Recurring</div>
                <Tag label={capitalizeFirstLetter(item?.repeat_method)} />
              </>
            ) : (
              <div className="whitespace-nowrap">Non-Recurring</div>
            )}
          </TableCell>
        </>
      )}
      <TableCell>
        <div className="flex items-center space-x-1 mb-2 text-sm leading-none whitespace-nowrap">
          <CustomIcon icon="watch_later" size="sm" />{' '}
          <span>
            {utcDateTimeToLocalString(
              item?.scheduled_at ?? item.created_at,
              true,
              true,
            )}
          </span>
        </div>
        <div className="flex items-center space-x-1 text-sm leading-none">
          <CustomIcon icon="calendar_today" size="sm" />
          <span>
            {isoToLocaleFormat(item?.scheduled_at ?? item.created_at, true)}
          </span>
        </div>
      </TableCell>
      <TableCell>
        <Status
          label={capitalizeAndRemoveUnderscore(item?.status)}
          isFailure={item?.status == 'FAILED'}
          className={
            item?.status == 'SENT'
              ? 'bg-green-100 text-primary-800 '
              : item?.status == 'IN_PROGRESS'
                ? 'bg-amber-100 text-warning '
                : ''
          }
        />
      </TableCell>
      <TableCell>{getFilterComponents()}</TableCell>
      <TableCell>
        <div className="flex space-x-2 justify-end">
          {/*<CustomButton
            onClick={() => {
              setModalData({type:'mobile', data:item?.users})
            }}
            isIconButton={true}
          >
            <CustomIcon icon="person" />
          </CustomButton>
          */}
          {isRecurring && (
            <CustomButton
              onClick={() => {
                if (isEditingAllowed()) {
                  navigate(`/notification/schedule/form`, { state: item })
                } else {
                  toast.info(
                    'This notification is scheduled to be sent within the next 30 minutes, and it cannot be edited.',
                  )
                }
              }}
              isIconButton={true}
              disabled={item.status === 'SENT' || item.status === 'FAILED'}
            >
              <CustomIcon icon="edit" />
            </CustomButton>
          )}
          {isRecurring && (
            <DangerButton
              onClick={() => {
                setDeleteModal(item)
              }}
              isIconButton={true}
              disabled={item.status === 'SENT' || item.status === 'FAILED'}
            >
              <CustomIcon icon="delete" />
            </DangerButton>
          )}
        </div>
      </TableCell>
    </TableRow>
  )
}

export default NotificationItem
